import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-shared',
  standalone: true,
  templateUrl: './shared.component.html',
  styleUrls: ['./shared.component.scss'],
})
export class SharedComponent {
  @Input()
  name!: string;
}
